import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20sports%20stadium%20at%20night%20with%20dynamic%20stadium%20lights%20illuminating%20a%20vast%20green%20field%2C%20atmospheric%20fog%20and%20dust%20particles%20floating%20in%20the%20air%2C%20cinematic%20sports%20photography%20with%20epic%20scale%20and%20moody%20lighting%2C%20dark%20rich%20tones%20with%20warm%20spotlight%20accents%2C%20professional%20sports%20broadcast%20aesthetic%2C%20no%20people%20visible%2C%20abstract%20and%20artistic%20sports%20atmosphere&width=1920&height=900&seq=kaiyun-hero-2026&orientation=landscape"
        alt="开云体育 - 全球顶级体育赛事平台"
        title="开云体育首页背景 - 体育赛事"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
          {t('home.hero.title')}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('home.hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3 rounded-md transition-colors text-sm whitespace-nowrap"
          >
            {t('home.hero.cta')}
          </Link>
          <Link
            to="/category/football"
            className="border border-white/30 hover:border-white/60 text-white font-medium px-8 py-3 rounded-md transition-colors text-sm whitespace-nowrap"
          >
            {t('home.hero.secondary')}
          </Link>
        </div>
      </div>
    </section>
  );
}